import { render, staticRenderFns } from "./UserRoleSelect.vue?vue&type=template&id=8fb83774&scoped=true&"
import script from "./UserRoleSelect.vue?vue&type=script&lang=js&"
export * from "./UserRoleSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fb83774",
  null
  
)

export default component.exports